import { Placement } from 'popper.js';
import {
  CSSProperties,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from 'react';
import * as React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { uniqueId } from '../../utils/randomId';
export type TextEllipsisOptions = {
  children?: ReactNode;
  textWidth: number | string;
  tooltip?: ReactNode | string;
  tooltipPosition?: Placement;
  style?: object;
  justifyCenter?: boolean;
};

const TextEllipsis = ({
  children,
  textWidth,
  tooltipPosition = 'bottom',
  tooltip,
  style,
  justifyCenter = true,
}: TextEllipsisOptions) => {
  const [id] = useState<string>(uniqueId('tooltip-'));

  const [toggle, setToggle] = useState(true);

  const textStyle = useMemo<CSSProperties>(() => {
    return toggle
      ? {
          width: textWidth,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }
      : {
          width: textWidth,
        };
  }, [toggle, textWidth]);

  const onClickEvent = useCallback(() => setToggle(!toggle), [toggle]);

  return (
    <div
      className={`${
        justifyCenter
          ? 'd-flex justify-content-center'
          : 'd-flex justify-content-start'
      }`}
    >
      <p id={id} onClick={onClickEvent} style={{ ...textStyle, ...style }}>
        {children}
      </p>
      {tooltip && (
        <UncontrolledTooltip
          placement={tooltipPosition}
          target={id}
          fade={false}
        >
          {tooltip}
        </UncontrolledTooltip>
      )}
    </div>
  );
};

export default TextEllipsis;
